<template>
  <div class="dis-result">
    <div class="i-menu">
      <ul>
        <li :class="{active: index == n}" v-for="(item, index) in menus" @click="toggle(index)">{{item.name}}</li>
      </ul>
      <div class="run" v-if="isCompile">
        <button class="compile-btn" @click="compile">编译运行</button>
      </div>
    </div>

    <div class="i-content">
      <div class="tab stdin-wrap" v-if="n==0">
        <input class="effect-2" type="text" placeholder="Placeholder Text" v-model="standand" @keyup="inputParam">
        <span class="focus-border"></span>
      </div>
      <div class="tab" v-if="n==1">
        <p class="compile-info" v-html="conetent"></p>
      </div>
      <div class="tab" v-if="n==2">
        <p class="compile-info" v-html="conetent"></p>
      </div>
      <div class="tab" v-if="n==3">
        <p class="compile-info" v-html="conetent"></p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import IO from 'socket.io-client'
import { ajaxAPI } from '@/utils/ajaxUtil'
import { API_URL, url } from '@/config/url_config'
export default {
  props: {
    isCompile: {
      type: String
    },
    options: {
      type: Object
    }
  },
  data () {
    return {
      menus: [
        {name: '标准'},
        {name: '编译'},
        {name: '错误'},
        {name: '结果'}
      ],
      n: 0,
      standand: '',
      conetent: ''
    }
  },
  created () {
    this.initOptions()
  },
  watch: {
    compileInfo: function () {
      console.log('compileInfo:', this.compileInfo)
      this.compileResultFun(this.compileInfo)
    },
    tab: function () {
      console.log('tab:', this.tab)
      this.n = this.tab
    },
    inputParam: function () {
      console.log('inputParam:', this.inputParam)
      this.standand = this.inputParam
    }
  },
  mounted () {
    console.log('this.options.role', this.options.role)
    let _this = this
    let socket = IO(url)
    if (!this.options.isEditor) {
      console.log('this.options.role', this.options.role)
      socket.on('compile.result', function (msg) {
        console.log('compile.result', msg)
        _this.compileResult(msg)
      })
    }
  },
  methods: {
    toggle (index) {
      let socket = IO(url)
      this.n = index
      if (this.options.role === 0) {
        socket.emit('check.tab', index, this.$route.params.roomId)
      }
    },
    initOptions () {
      if (this.options.role === undefined) {
        this.options.role = 0
      }
      if (this.options.isCompile === undefined) {
        this.options.isCompile = true
      }
      if (this.options.isEditor === undefined) {
        this.options.isEditor = true
      }
    },
    inputParam () {
      let socket = IO(url)
      if (this.options.role === 0) {
        socket.emit('input.param', this.standand, this.$route.params.roomId)
      } else {
        return false
      }
    },
    compile () {
      let socket = IO(url)
      var compileData = {
        code: this.$store.state.codeContent || '',
        langid: 10,
        input: this.standand,
        userId: Math.floor(Math.random() * 10000)
      }
      console.log(compileData)
      // socket.emit('compile.result', compileData, this.$route.params.roomId)
      ajaxAPI('POST', API_URL + '/submit/submitCode/api', compileData).then(data => {
        console.log(data)
        if (this.options.role === 0) {
          socket.emit('compile.result', data, this.$route.params.roomId)
        }
        this.compileResult(data)
      })
    },
    compileResult (data) {
      console.log(data)
      if (data.status === 200) {
        console.log('3456776543456789')
        if (data.data.cmpinfo !== '') {
          this.n = 1
          this.conetent = data.data.cmpinfo.replace(/\n/g, '<br />')
        } else if (data.data.stderr !== '') {
          this.n = 2
          this.conetent = data.data.stderr.replace(/\n/g, '<br />')
        } else if (data.data.output !== '') {
          this.n = 3
          this.conetent = data.data.output
        }
      } else {
        this.n = 1
      }
      if (data.status === 500) {
        this.n = 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dis-result{
  width: 100%;
  height: 100%;
  background: #fff;
  
  .active{
    color: #FFF;
    background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
    background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
    -webkit-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
    box-shadow: 0px 0px 2px 0px #B3E5FF;
    border: none;
    border-radius: 30px
  }
  .i-menu{
    height: 35px;
    background: rgba(31, 182, 255, .1);
    display: flex;
    color: #1FB6FF;
    padding-left: 60px;

    ul{
      flex: 1;
      padding-top: 3px;
      text-align: center;
    }
    li{
      float: left;
      width: 70px;
      height: 28px;
      text-align: center;
      line-height: 30px;
      list-style: none;
      margin-right:2px;
      cursor: pointer;
      font-weight: 400;

      &:hover{
        color: #FFF;
        background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
        background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
        -webkit-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
        transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
        box-shadow: 0px 0px 2px 0px #B3E5FF;
        border: none;
        border-radius: 30px
      }
    }
    .run{
      text-align: right;
      padding-right: 24px;
      line-height: 36px;

      .compile-btn{
        padding: 4px 18px;
      }
    }
  }
  .i-content{
    width: 100%;
    height: calc(100% - 36px);
    box-sizing: border-box;
    background-color: #fff;
    overflow: hidden;
    .tab{
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 8px 12px;
      overflow: auto;

      .compile-info{
        color: red;
      }
    }
    .stdin-wrap{
      :focus{
        outline: none;
      }
      input[type="text"]{
        color: #333; 
        width: 100%; 
        box-sizing: border-box; 
        letter-spacing: 1px;
      }
      .effect-2{
        border: 0; 
        padding: 7px 0; 
        border-bottom: 1px solid #ccc;
      }
      .effect-2 ~ .focus-border{
        position: absolute; 
        bottom: 0; 
        left: 50%; 
        width: 0; 
        height: 2px; 
        background-color: #3399FF; 
        transition: 1s;
      }
      .effect-2:focus ~ .focus-border{
        width: 100%; 
        transition: 1s; 
        left: 0;
      }
    }
  }
} 
</style>



// WEBPACK FOOTER //
// index.vue?26603b2b